<template>
    <div class="flex flex-col w-full h-full min-h-0 mx-auto p-4 shadow overflow-hidden">
        <div class="flex-shrink-0">
            <AddButtons
                :uuid="uuid"
                :extensions="extensions"
                :grav-color="gravColor"
                :is-graver-mode="isGraverMode"
                :added-image="addedImage"
                :added-text="addedText"
                :forced-color="forcedColor"
                :remove-logo="removeLogo"
                @add:text-layer="addTextLayer"
                @add:image-layer="addImageLayer"
                @update:colors="updateColors"
                @update:quality-score="updateQualityScore"
            ></AddButtons>
        </div>
        <div
            class="flex-grow min-h-0 overflow-y-auto bg-white rounded-md p-4"
            ref="canvas"
        >
            <span v-if="addedImage || addedText"
                  class="text-sm font-semibold mb-4">{{ layersTitle }}</span>
            <ImageLayer
                ref="imageLayerRef"
                :uuid="uuid"
                :image-data="imageData"
                :removeLogo="removeLogo"
                :resizeLogo="resizeLogo"
                :colors="detectedColors"
                :cropFileName="cropFileName"
                :boundBoxValidator="boundBoxValidator"
                :boundBoxFitter="boundBoxFitter"
                :limitColorExceeded="limitColorExceeded"
                :printMethod="printMethod"
                :forcedColor="forcedColor"
                :borderRotation="borderRotation"
                class="mb-4"
                @update:image-layer="handleImageLayerEmit"
                @remove:image-layer="removeImageLayer"
                @update:replace-color-image="handleReplaceColorImage"
            >
            </ImageLayer>
            <div class="py-2"></div>
            <TextLayer
                ref="textLayerRef"
                :addedText="addedText"
                :forcedColor="forcedColor"
                :removeText="removeText"
                :removeTransformerSelection="removeTransformerSelection"
                :revertFontSize="revertFontSize"
                :revertTextContent="revertTextContent"
                :textValidation="textValidation"
                @update:text-layer="handleTextLayerEmit"
                @update:text-content="handleTextContentEmit"
                @remove:text-layer="handleTextLayerRemove"
            >
            </TextLayer>
        </div>

        <!--        <div-->
        <!--            class="flex-grow bg-white rounded-md p-4"-->
        <!--            ref="canvas"-->
        <!--        >-->
        <!--            <span v-if="addedImage || addedText"-->
        <!--                  class="text-sm font-semibold mb-4">KOLORY</span>-->

        <!--            <ImageColorLayer-->
        <!--                v-if="detectedColors && detectedColors.length>0"-->
        <!--                :options="detectedColors"-->
        <!--            >-->
        <!--            </ImageColorLayer>-->
        <!--        </div>-->

        <div class="flex-shrink-0">
            <!--            <div v-if="limitColorExceeded"-->
            <!--                 class="flex items-center gap-2 bg-orange-400 bg-opacity-30 p-2 rounded pl-4 mt-2">-->
            <!--                <span><IconOrangeQuestionMark/></span>-->
            <!--                <span>{{ maxColorsMessage }} <b>{{ limitColors }}</b></span>-->
            <!--            </div>-->
            <!--            <QualityChecker v-if="!limitColorExceeded"></QualityChecker>-->
            <div
                v-if="isLogoAreaExceeded"
                class="z-[11] w-full px-4 py-3 rounded-lg mb-3 flex items-center justify-between bg-red-50 border border-red-200 text-red-900"
            >
                <span class="text-sm font-normal">{{ logoAreaExceededMessage }}</span>
            </div>
            <div
                v-if="showQualityRecheckButton"
                class="z-[11] w-full px-4 py-3 rounded-lg mb-3  flex items-center justify-between transition"
                :class="qualityRecheckLoading ? 'cursor-wait bg-orange-100 border-orange-200 text-orange-400' : 'bg-orange-50 border-orange-200 text-orange-900 hover:bg-orange-100'"
            >
                <div class="flex items-center gap-3 w-full">
                    <div class="flex-shrink-0">
                        <svg
                            v-if="qualityRecheckLoading"
                            class="h-5 w-5 animate-spin text-orange-500"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                        >
                            <circle
                                class="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                stroke-width="4"
                            />
                            <path
                                class="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.372 0 0 5.372 0 12h4z"
                            />
                        </svg>
                        <IconOrangeQuestionMark
                            v-else
                            class="h-5 w-5"
                        />
                    </div>
                    <div class="flex items-center justify-between w-full text-sm font-normal">
                        <span class="text-orange-900">{{ qualityCheckBannerText }}</span>
                        <button
                            type="button"
                            class="text-xs font-medium underline underline-offset-4 tracking-wide px-1"
                            :class="qualityRecheckLoading ? 'text-orange-400 cursor-not-allowed' : 'text-orange-900'"
                            :disabled="qualityRecheckLoading"
                            @click.stop="runQualityRecheck"
                        >
                            {{ qualityCheckButtonText }}
                        </button>
                    </div>
                </div>
            </div>
            <div class="mt-4 flex gap-6 justify-between">
                <button
                    @click="downloadFile('pdf')"
                    class=" z-[11] flex items-center gap-2 w-1/2 px-4 py-2 rounded"
                    :class="hasContent && !limitColorExceeded && !props.downloadPdfLoading ? 'border border-gray-400 text-gray-600 hover:bg-gray-300' : 'text-gray-400 bg-gray-200 cursor-not-allowed'"
                    :disabled="!hasContent || (limitColorExceeded && !isDigitalPrint) || props.downloadPdfLoading"
                >
                    <svg
                        v-if="props.downloadPdfLoading"
                        class="h-5 w-5 animate-spin text-gray-500"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <circle
                            class="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            stroke-width="4"
                        />
                        <path
                            class="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.372 0 0 5.372 0 12h4z"
                        />
                    </svg>
                    <IconDownload v-else/>
                    <span>{{ downloadPdfText }}</span>
                </button>
                <button
                    @click="downloadFile('png')"
                    class=" z-[11] flex items-center gap-2 w-1/2 px-4 py-2 rounded"
                    :class="hasContent && !limitColorExceeded ? 'border border-gray-400 text-gray-600 hover:bg-gray-300' : 'text-gray-400 bg-gray-200 cursor-not-allowed'"
                    :disabled="!hasContent || (limitColorExceeded && !isDigitalPrint)"
                >
                    <IconDownload/>
                    <span>{{ downloadPngText }}</span>
                </button>
            </div>
            <button
                @click="toggleConfirmation"
                class="w-full px-4 py-2 rounded mt-4 relative z-[11]"
                :class="[
                    hasContent && !limitColorExceeded && !showQualityRecheckButton && !isLogoAreaExceeded
                        ? (confirmed && !editAfterSave
                            ? 'text-black bg-white border border-black hover:bg-gray-100'
                            : 'text-white bg-orange-500 hover:bg-orange-600')
                        : 'text-gray-400 bg-gray-200 cursor-not-allowed'
                ]"
                :disabled="!hasContent || (limitColorExceeded && !isDigitalPrint) || showQualityRecheckButton || isLogoAreaExceeded"
            >
                {{ confirmVisualizationText }}
            </button>
            <p class="mt-2 text-sm text-cyan-500">
                {{ confirmVisualizationNoteText }}
            </p>
            <div
                v-if="confirmed && !editAfterSave"
                class="fixed inset-0 bg-black bg-opacity-0 z-[10]"
            ></div>
        </div>
    </div>
    <Modal
        v-model="qualityCheckModalOpened"
        :title="qualityCheckTitle"
        :size="'md'">
        <div>
            <p class="text-sm text-gray-600 mb-6">
                {{ qualityCheckMessage }}
            </p>
        </div>
        <div class="border border-gray-400 rounded">
            <div v-if="isImageFile"
                 class="p-6 mx-4 flex justify-center"
            >
                <img
                    v-if="qualityCheckPreview"
                    :src="qualityCheckPreview"
                    alt="Uploaded file preview"
                    class="w-auto max-h-[50vh]"
                />
            </div>
            <div v-else
                 class="p-6 mx-4 flex items-center justify-center"
            >
                <div v-if="qualityCheckProcessing"
                     class="flex items-center justify-center h-[50vh]">
                    <svg
                        class="h-12 w-12 animate-spin text-gray-500"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <circle
                            class="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            stroke-width="4"
                        />
                        <path
                            class="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.372 0 0 5.372 0 12h4z"
                        />
                    </svg>
                </div>
                <img
                    v-else-if="qualityCheckPreview"
                    :src="qualityCheckPreview"
                    alt="Uploaded file preview"
                    class="w-auto max-h-[50vh]"
                />
            </div>
        </div>

        <div>
            <div class="flex justify-between text-xs text-gray-600 my-2">
                <span :class="qualityMark == 'bad' ? 'text-red-600 font-medium' : ''">{{ badQualityText }}</span>
                <span :class="qualityMark == 'okay' ? 'text-orange-600 font-medium' : ''">{{ okayQualityText }}</span>
                <span :class="qualityMark == 'good' ? 'text-green-600 font-medium' : ''">{{ goodQualityText }}</span>
            </div>
            <div class="w-full bg-gray-200 h-2 rounded-full flex items-center">
                <div
                    class="h-2 bg-green-600 rounded-full"
                    :style="{ width: qualityScore + '%' }"
                ></div>
            </div>
            <div class="flex justify-center">
                <span
                    class="text-sm text-gray-700"
                >
                  {{ qualityScore }}%
                </span>
            </div>

            <div
                v-if="printMethod && (printMethod.startsWith('L') || printMethod.startsWith('TC')) && logoColorsCount > 1"
                class="flex justify-center space-x-2 mt-2">
                <div class="flex items-center gap-3 bg-blue-50 p-4 rounded-lg mb-4">
                    <div class="flex-shrink-0">
                        <div class="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center">
                            <span class="text-white text-sm font-bold">!</span>
                        </div>
                    </div>
                    <span class="text-sm">{{ graverColorReplaceMessage }}</span>
                </div>
            </div>
        </div>

        <div class="flex justify-end mt-6">
            <button
                class="px-4 py-2 bg-gray-800 text-white rounded hover:bg-gray-600"
                @click="qualityCheckModalOpened = false"
            >
                {{ qualityCheckCloseText }}
            </button>
        </div>
    </Modal>
</template>
<script setup>
import {computed, nextTick, onMounted, ref, watch} from "vue";
import AddButtons from "./upload/AddButtons.vue"
import TextLayer from "./settings/TextLayer.vue";
import ImageLayer from "./settings/ImageLayer.vue";
import IconDownload from "./icons/IconDownload.vue";
import IconOrangeQuestionMark from "./icons/IconOrangeQuestionMark.vue";
import {useTranslation} from '../composables/useTranslation.js';
import Modal from "./Modal.vue";
import {eventBus} from "../eventBus";


const {$t} = useTranslation()

const addedImage = ref(false)
const addedText = ref(false)
const imageData = ref(null)
const detectedColors = ref([])
const limitColors = ref(99)
const limitColorExceeded = ref(false)
const currentLogoSize = ref(null)
const lastQualityCheckSize = ref(null)
const currentLogoPx = ref(null)
const currentImageId = ref(null)
const qualityRecheckLoading = ref(false)
const qualityCheckModalOpened = ref(false)
const qualityCheckPreview = ref(null)
const qualityCheckProcessing = ref(false)
const qualityScore = ref(0)
const logoColorsCount = ref(0)

const imageLayerRef = ref(null)
const textLayerRef = ref(null)

const layersTitle = ref('')
const maxColorsMessage = ref('')
const downloadPdfText = ref('')
const downloadPngText = ref('')
const confirmVisualizationText = ref('')
const confirmVisualizationNoteText = ref('')
const qualityCheckBannerText = ref('')
const qualityCheckButtonText = ref('')
const qualityCheckTitle = ref('')
const qualityCheckCloseText = ref('')
const badQualityText = ref('')
const okayQualityText = ref('')
const goodQualityText = ref('')
const goodQualityMessage = ref('')
const okayQualityMessage = ref('')
const badQualityMessage = ref('')
const graverColorReplaceMessage = ref('')
const logoAreaExceededTemplate = ref('')

const props = defineProps({
    uuid: {
        type: String,
        required: false
    },
    removeLogo: {
        type: Number,
        default: 0, // Wartość domyślna
    },
    resizeLogo: {
        type: Object,
        default: null,
    },
    removeText: {
        type: Number,
        default: 0, // Wartość domyślna
    },
    extensions: {
        type: Array,
        default: [], // Wartość domyślna
    },
    historyColors: {
        type: Object,
        default: null,
    },
    visualization: {
        type: Object,
        default: null,
    },
    cropFileName: {
        type: String,
        default: null,
    },
    printMethod: {
        type: String,
        default: null,
    },
    gravColor: {
        type: String,
        default: null,
    },
    boundBoxValidator: {
        type: Function,
        default: null,
    },
    boundBoxFitter: {
        type: Function,
        default: null,
    },
    removeTransformerSelection: {
        type: Function,
        default: null,
    },
    revertFontSize: {
        type: Number,
        default: null,
    },
    revertTextContent: {
        type: String,
        default: null,
    },
    textValidation: {
        type: Boolean,
        default: true,
    },
    confirmed: {
        type: Boolean,
        default: false,
    },
    editAfterSave: {
        type: Boolean,
        default: false,
    },
    borderRotation: {
        type: Number,
        default: 0,
    },
    downloadPdfLoading: {
        type: Boolean,
        default: false,
    },
    logoAreaStatus: {
        type: Object,
        default: null,
    },
});

const isDigitalPrint = computed(() => {
    return props.printMethod && (
        props.printMethod.startsWith('H') ||
        props.printMethod.startsWith('D') ||
        props.printMethod.startsWith('FC') ||
        props.printMethod.startsWith('UV') ||
        props.printMethod.startsWith('PL') ||
        props.printMethod === 'TF3A' ||
        props.printMethod === 'SL'
    );
});

const hasContent = computed(() => {
    return addedImage.value || addedText.value;
});

/** Jakość była już zweryfikowana po stronie serwera (pole visualization.validated). */
const isVisualizationQualityValidated = computed(() => {
    const v = props.visualization?.validated;
    return v === true || v === 1 || v === '1';
});

const availableColors = computed(() => {
    let tmpColors = [];

    if (detectedColors && detectedColors.value && detectedColors.value.colors && detectedColors.value.colors.length > 0) {
        tmpColors = [...detectedColors.value.colors]
    }

    let uniqueColors = [];
    tmpColors.forEach((color, index) => {

        if (!uniqueColors.find(tmp => tmp.pantone === color.pantone)) {
            uniqueColors.push(color);
        }
    });


    return uniqueColors;
});

const isGraverMode = computed(() =>
    props.printMethod && (props.printMethod.startsWith('L') || props.printMethod.startsWith('TC'))
);

const graverForcedColor = ref(null);

const forcedColor = computed(() => {
    if (!isGraverMode.value) return null;
    if (availableColors.value.length > 0) {
        const first = availableColors.value[0];
        return {
            hex: first.hex,
            pantone: first.pantone,
            name: first.pantone || first.name || first.hex,
        };
    }
    return graverForcedColor.value || null;
});

watch(() => props.historyColors, (newColors, oldColors) => {
    if (newColors && newColors.colors && newColors.colors.length > 0) {
        detectedColors.value = {...newColors}
        let textColor = 0;

        if (addedImage.value && addedText.value && textLayerRef.value && imageLayerRef.value) {
            let realColors = imageLayerRef.value.getRealColors();
            let currentTextPantone = textLayerRef.value.getCurrentPantone() || '';

            if (realColors.find(realColor => realColor.pantone.toUpperCase() === currentTextPantone.toUpperCase())) {
                textColor = 0;
            } else {
                textColor = 1;
            }
        }


        if (isDigitalPrint.value || (props.printMethod && (props.printMethod.startsWith('L') || props.printMethod.startsWith('TC')))) {
            limitColorExceeded.value = false;
        } else {
            if (availableColors.value.length + textColor > limitColors.value) {
                limitColorExceeded.value = true;
            } else {
                limitColorExceeded.value = false;
            }
        }


    }
}, {
    deep: true,      // śledzi zmiany wewnątrz tablicy/obiektu
    immediate: true  // uruchamia callback od razu po inicjalizacji
})

watch(() => props.visualization, (newVisualization, oldVisualization) => {
    if (newVisualization) {
        imageData.value = newVisualization.logo
        addedImage.value = true
        if (newVisualization.text_config && newVisualization.text_config.visible) {
            if (textLayerRef && textLayerRef.value) {
                textLayerRef.value.initFromVisualization(newVisualization)

                addedText.value = true;
            }

        }

        emit('update:image', newVisualization.logo)
        emit('update:colors', newVisualization.colors)


    }
}, {
    deep: true,      // śledzi zmiany wewnątrz tablicy/obiektu
    immediate: true  // uruchamia callback od razu po inicjalizacji
})

watch(() => [props.confirmed, props.editAfterSave], async ([newConfirmed, newEditAfterSave]) => {
    if (newConfirmed !== undefined) {
        if (newConfirmed && !newEditAfterSave) {
            confirmVisualizationText.value = await $t('buttons.edit_visualization', 'Edytuj Wizualizację')
        } else {
            confirmVisualizationText.value = await $t('buttons.confirm_visualization', 'Zatwierdź Wizualizację')
        }
    }
}, {
    immediate: true
})
onMounted((async () => {
    const urlParams = new URLSearchParams(window.location.search);

    limitColors.value = urlParams.get('limit_color') ?? 5;

    layersTitle.value = await $t('layers.title', 'WARSTWY')
    maxColorsMessage.value = await $t('colors.max_colors_message', 'Maksymalna liczba kolorów to :')
    downloadPdfText.value = await $t('buttons.download_pdf', 'Pobierz PDF')
    downloadPngText.value = await $t('buttons.download_png', 'Pobierz PNG')
    confirmVisualizationNoteText.value = await $t('buttons.confirm_visualization_note', 'Po zatwierdzeniu wizualizacji nasz dział graficzny dodatkowo skontroluje Twoje pliki i w razie wykrycia problemów skontaktuje się z Tobą przed uruchomieniem produkcji.')
    qualityCheckBannerText.value = await $t('quality.recheck_banner', 'Jakość grafiki wymaga sprawdzenia')
    qualityCheckButtonText.value = await $t('quality.recheck_action', 'SPRAWDŹ')
    qualityCheckTitle.value = await $t('quality.checking_title', 'Sprawdzanie jakości pliku')
    qualityCheckCloseText.value = await $t('text.close', 'Zamknij')
    badQualityText.value = await $t('quality.bad', 'Zła jakość')
    okayQualityText.value = await $t('quality.okay', 'Mogło być lepiej')
    goodQualityText.value = await $t('quality.good', 'Dobra jakość')
    goodQualityMessage.value = await $t('quality.good_message', 'Sprawdziliśmy jakość Twojego pliku i wszystko jest w porządku! Nie przewidujemy żadnych problemów podczas drukowania.')
    okayQualityMessage.value = await $t('quality.okay_message', 'Sprawdziliśmy jakość Twojego pliku – jest akceptowalna. Drukowanie nie powinno sprawić trudności, jednak dla uzyskania optymalnych rezultatów zalecamy przesłanie pliku o wyższej jakości.')
    badQualityMessage.value = await $t('quality.bad_message', 'Ta grafika zawiera zbyt wiele drobnych elementów (szczegóły wskazane poniżej). Zalecamy wgranie nowej grafiki, aby zapewnić lepsze rezultaty druku.')
    graverColorReplaceMessage.value = await $t('quality.grav_message', 'Ta grafika zawiera zbyt wiele drobnych elementów (szczegóły wskazane poniżej). Zalecamy wgranie nowej grafiki, aby zapewnić lepsze rezultaty druku.')
    logoAreaExceededTemplate.value = await $t('quality.logo_area_exceeded', 'Rozmiar logo przekracza maksymalną powierzchnię dla tej techniki, która wynosi {size} cm2. Zmniejsz logo lub zmień technikę znakowania.')

    if (props.confirmed && !props.editAfterSave) {
        confirmVisualizationText.value = await $t('buttons.edit_visualization', 'Edytuj Wizualizację')
    } else {
        confirmVisualizationText.value = await $t('buttons.confirm_visualization', 'Zatwierdź Wizualizację')
    }
}))

const addTextLayer = (payload) => {
    if (addedText.value) return
    if (payload?.forcedColor) {
        graverForcedColor.value = payload.forcedColor;
    }
    addedText.value = true

    let textColor = 1;

    let localColors = availableColors.value;


    if (addedImage.value && textLayerRef.value && imageLayerRef.value) {
        let realColors = imageLayerRef.value.getRealColors();
        localColors = realColors;
        let currentTextPantone = textLayerRef.value.getCurrentPantone() || '';

        if (realColors.find(realColor => realColor.pantone.toUpperCase() === currentTextPantone.toUpperCase())) {
            textColor = 0;
        } else {
            textColor = 1;
        }
    }


    if (isDigitalPrint.value || (props.printMethod && (props.printMethod.startsWith('L') || props.printMethod.startsWith('TC')))) {
        limitColorExceeded.value = false;
    } else {
        if (localColors.length + textColor > limitColors.value) {
            limitColorExceeded.value = true;
        } else {
            limitColorExceeded.value = false;
        }
    }

}

const addImageLayer = (data, changedOriginalLogo) => {
    imageData.value = data
    addedImage.value = true
    graverForcedColor.value = null

    emit('update:image', data, changedOriginalLogo)
}

const updateColors = (data) => {
    detectedColors.value = data
    let textColor = 0;

    if (addedImage.value && addedText.value && textLayerRef.value && imageLayerRef.value) {
        let realColors = imageLayerRef.value.getRealColors();
        let currentTextPantone = textLayerRef.value.getCurrentPantone() || '';

        if (realColors.find(realColor => realColor.pantone.toUpperCase() === currentTextPantone.toUpperCase())) {
            textColor = 0;
        } else {
            textColor = 1;
        }
    }

    if (isDigitalPrint.value || (props.printMethod && (props.printMethod.startsWith('L') || props.printMethod.startsWith('TC')))) {
        limitColorExceeded.value = false;
    } else {
        if (availableColors.value.length + textColor > limitColors.value) {
            limitColorExceeded.value = true;
        } else {
            limitColorExceeded.value = false;
        }
    }

    emit('update:colors', data)
}

const removeImageLayer = () => {
    if (qualityCheckPreview.value && qualityCheckPreview.value.startsWith('blob:')) {
        URL.revokeObjectURL(qualityCheckPreview.value)
    }

    imageData.value = null
    addedImage.value = false
    currentLogoSize.value = null
    lastQualityCheckSize.value = null
    currentLogoPx.value = null
    detectedColors.value = []
    qualityCheckPreview.value = null
    qualityCheckModalOpened.value = false
    qualityCheckProcessing.value = false

    emit('update:image', {})
    emit('update:colors', {colors: []})
}
const handleReplaceColorImage = (replaceColorImagePreview, historyColorObject, actualColorsCount) => {
    let textColor = 0;

    if (addedImage.value && addedText.value && textLayerRef.value && imageLayerRef.value) {
        let realColors = imageLayerRef.value.getRealColors();
        let currentTextPantone = textLayerRef.value.getCurrentPantone() || '';

        if (realColors.find(realColor => realColor.pantone.toUpperCase() === currentTextPantone.toUpperCase())) {
            textColor = 0;
        } else {
            textColor = 1;
        }
    }


    if (isDigitalPrint.value || (props.printMethod && (props.printMethod.startsWith('L') || props.printMethod.startsWith('TC')))) {
        limitColorExceeded.value = false;
    } else {
        if (limitColors.value < actualColorsCount + textColor) {
            limitColorExceeded.value = true;
        } else {
            limitColorExceeded.value = false;
        }
    }

    emit('update:colors-file', replaceColorImagePreview, historyColorObject)
}

const downloadFile = (type) => {
    if (limitColorExceeded.value && !isDigitalPrint.value) {
        return;
    }
    emit('download:visualization', type)
}

const qualityCheckMessage = computed(() => {
    if (qualityScore.value > 80) {
        return goodQualityMessage.value
    } else if (qualityScore.value <= 80 && qualityScore.value >= 30) {
        return okayQualityMessage.value
    } else {
        return badQualityMessage.value
    }
})

const qualityMark = computed(() => {
    if (qualityScore.value > 80) {
        return 'good'
    } else if (qualityScore.value <= 80 && qualityScore.value >= 30) {
        return 'okay'
    } else {
        return 'bad'
    }
})

const hasSizeChanged = (currentSize, checkedSize) => {
    if (!currentSize || !checkedSize) {
        return false;
    }
    const widthDiff = Math.abs(parseFloat(currentSize.width) - parseFloat(checkedSize.width));
    const heightDiff = Math.abs(parseFloat(currentSize.height) - parseFloat(checkedSize.height));
    return widthDiff > 0.01 || heightDiff > 0.01;
}

const showQualityRecheckButton = computed(() => {
    if (isRasterImage.value) {
        return false;
    }
    if (eventBus.forceQualityRecheck) {
        if (isVisualizationQualityValidated.value) {
            return false;
        }
        return !!imageData.value;
    }
    if (!imageData.value || !currentLogoSize.value || !lastQualityCheckSize.value) {
        return false;
    }
    return hasSizeChanged(currentLogoSize.value, lastQualityCheckSize.value);
})
const isLogoAreaExceeded = computed(() => {
    return !!(props.logoAreaStatus && props.logoAreaStatus.exceeded);
})
const logoAreaExceededMessage = computed(() => {
    if (!isLogoAreaExceeded.value || !props.logoAreaStatus?.maxArea) {
        return '';
    }
    const size = Number(props.logoAreaStatus.maxArea).toFixed(2);
    return logoAreaExceededTemplate.value.replace('{size}', size);
})

const calculateLogoSize = (resizePayload) => {
    if (!resizePayload || !resizePayload.scale || !resizePayload.config) {
        return null;
    }
    if (!resizePayload.scale.line || !resizePayload.scale.dim) {
        return null;
    }

    const ratio = resizePayload.scale.dim / resizePayload.scale.line;
    return {
        width: parseFloat((ratio * resizePayload.config.width * 10).toFixed(2)),
        height: parseFloat((ratio * resizePayload.config.height * 10).toFixed(2)),
    }
}

const syncCurrentLogoSize = (payload) => {
    const nextSize = calculateLogoSize(payload);
    if (!nextSize) {
        return;
    }
    currentLogoSize.value = nextSize;
    if (payload.config?.width && payload.config?.height) {
        currentLogoPx.value = {
            width: payload.config.width,
            height: payload.config.height,
        }
    }

    if (!lastQualityCheckSize.value && imageData.value) {
        lastQualityCheckSize.value = {...nextSize};
    }
}

const markQualityChecked = () => {
    if (currentLogoSize.value) {
        lastQualityCheckSize.value = {...currentLogoSize.value};
    }
}

watch(
    () => props.resizeLogo,
    (newValue) => {
        if (newValue) {
            syncCurrentLogoSize(newValue);
        }
    },
    {deep: true, immediate: true}
);

watch(
    imageData,
    (newValue, oldValue) => {
        const newId = newValue && newValue.id ? newValue.id : null;
        const oldId = oldValue && oldValue.id ? oldValue.id : null;

        if (newId !== oldId) {
            currentImageId.value = newId;
            // Logo changed – reset quality check baseline so the recheck button hides
            currentLogoSize.value = null;
            currentLogoPx.value = null;
            lastQualityCheckSize.value = null;
        }
    },
    {deep: true}
)

const isRasterImage = computed(() => {
    if (!imageData.value || !imageData.value.file_name) {
        return false;
    }

    const isBitmapPdf = imageData.value.custom_properties?.is_bitmap_pdf === true
        || imageData.value.custom_properties?.is_bitmap_pdf === 1
        || imageData.value.custom_properties?.is_bitmap_pdf === '1';

    if (isBitmapPdf) {
        return true;
    }

    const rasterExtensions = ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'tiff', 'tif', 'webp'];
    const fileName = imageData.value.file_name;
    const fileExtension = fileName.slice((fileName.lastIndexOf(".") - 1 >>> 0) + 1).toLowerCase();

    if (imageData.value.mime_type) {
        const rasterMimeTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/bmp', 'image/gif', 'image/tiff', 'image/webp'];
        if (rasterMimeTypes.includes(imageData.value.mime_type)) {
            return true;
        }
    }

    return rasterExtensions.includes(fileExtension);
});

const isImageFile = computed(() => {
    if (!imageData.value) {
        return false;
    }
    const mime = imageData.value.mime_type || '';
    if (mime) {
        return mime.startsWith('image/');
    }
    const fileName = imageData.value.file_name || '';
    const extension = fileName.slice((fileName.lastIndexOf(".") - 1 >>> 0) + 1).toLowerCase();
    return ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'tiff', 'tif', 'webp', 'svg'].includes(extension);
})

const urlToFile = async (url, filename, mimeType) => {
    const response = await fetch(url);
    const blob = await response.blob();
    return new File([blob], filename, {type: mimeType});
}

const fetchQualityCheckFile = async (fileName) => {
    if (!fileName || !props.uuid) {
        return null;
    }

    const response = await fetch(
        `/api/file?file_name=${encodeURIComponent(fileName)}&uuid=${encodeURIComponent(props.uuid)}`
    );

    if (!response.ok) {
        return null;
    }

    const blob = await response.blob();
    if (!blob || blob.size === 0) {
        return null;
    }

    const mimeType = blob.type || 'image/svg+xml';
    return new File([blob], fileName, {type: mimeType});
}

const resolveQualityRecheckFile = async () => {
    const candidates = [
        props.cropFileName,
        detectedColors.value?.file,
        props.visualization?.colors?.file,
    ].filter(Boolean);

    const uniqueCandidates = [...new Set(candidates)];
    uniqueCandidates.sort((a, b) => {
        const aCrop = a.includes('-crop.') ? 0 : 1;
        const bCrop = b.includes('-crop.') ? 0 : 1;
        return aCrop - bCrop;
    });

    for (const fileName of uniqueCandidates) {
        const file = await fetchQualityCheckFile(fileName);
        if (file) {
            return file;
        }
    }

    return urlToFile(
        imageData.value.original_url,
        imageData.value.file_name,
        imageData.value.mime_type
    );
}

const buildQualityParams = () => {
    const urlParams = new URLSearchParams(window.location.search);

    let variantsArray = urlParams.get('variants');
    if (variantsArray) {
        variantsArray = variantsArray.replaceAll(" ", "").split(',');
    } else {
        variantsArray = [];
    }

    let erpCode = urlParams.get('erp_code') ?? 'V4201-19';
    if (variantsArray.length > 0) {
        erpCode = variantsArray[0];
    }

    return {
        erpCode,
        printPlaceName: urlParams.get('print_place_name') ?? 'panel 1',
        printPlaceSize: urlParams.get('print_place_size') ?? '200x120',
        printMethod: props.printMethod ?? urlParams.get('print_method') ?? 'TF1',
    };
}

const runQualityRecheck = async () => {
    if (!imageData.value) {
        return;
    }

    eventBus.forceQualityRecheck = false;
    qualityRecheckLoading.value = true;
    qualityCheckProcessing.value = true;
    if (qualityCheckPreview.value && qualityCheckPreview.value.startsWith('blob:')) {
        URL.revokeObjectURL(qualityCheckPreview.value)
    }
    qualityCheckPreview.value = null;

    try {
        const file = await resolveQualityRecheckFile();
        const params = buildQualityParams();
        const formData = new FormData()
        formData.append('file', file)
        formData.append('erp_code', params.erpCode)
        formData.append('print_place_name', params.printPlaceName)
        formData.append('print_place_size', params.printPlaceSize)
        formData.append('print_method', params.printMethod)
        formData.append('uuid', props.uuid)
        if (currentLogoPx.value?.width && currentLogoPx.value?.height) {
            formData.append('logoWidth', currentLogoPx.value.width)
            formData.append('logoHeight', currentLogoPx.value.height)
        }
        if (currentLogoSize.value?.width && currentLogoSize.value?.height) {
            formData.append('logoWidthMm', currentLogoSize.value.width)
            formData.append('logoHeightMm', currentLogoSize.value.height)
        }

        const response = await fetch("/api/file/quality-check", {
            method: "POST",
            body: formData,
        });

        if (!response.ok) {
            throw new Error('Błąd podczas pobierania pliku');
        }

        const qualityHeader = response.headers.get("Quality");
        qualityScore.value = parseInt(qualityHeader) || 0;
        emit('update:quality-score', qualityScore.value);

        const colorsCount = response.headers.get("Colors-Count");
        logoColorsCount.value = parseInt(colorsCount) || 0;

        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        qualityCheckPreview.value = url;

        markQualityChecked();
        qualityCheckModalOpened.value = true;

        if (!(props.confirmed === true && props.editAfterSave)) {
            await nextTick();
            const waitForSave = (eventName) => new Promise((resolve) => emit(eventName, resolve));
            await waitForSave('save:visualization');
        }
    } catch (error) {
        console.error('Błąd podczas sprawdzania jakości:', error);
    } finally {
        qualityRecheckLoading.value = false;
        qualityCheckProcessing.value = false;
    }
}

const toggleConfirmation = async () => {
    if ((limitColorExceeded.value && !isDigitalPrint.value) || isLogoAreaExceeded.value) {
        return;
    }

    if (props.confirmed && !props.editAfterSave) {
        emit('update:edit-after-save', true);

        window.parent.postMessage({
            type: 'VISUALIZATION_CONFIRMED',
            payload: {
                uuid: props.uuid,
                confirmed: 0
            }
        }, '*');
        return;
    }

    if (props.confirmed && props.editAfterSave) {
        const waitForSave = (eventName) => new Promise((resolve) => emit(eventName, resolve));

        await waitForSave('save:visualization');
        await waitForSave('save:visualization-snap');
        await waitForSave('save:production-svg');

        window.parent.postMessage({
            type: 'VISUALIZATION_CONFIRMED',
            payload: {
                uuid: props.uuid,
                confirmed: 1
            }
        }, '*');
        return;
    }

    if (!props.uuid) {
        console.error('Brak UUID dla wizualizacji');
        return;
    }

    try {
        const response = await fetch('/api/visualization/toggle-confirmation', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                uuid: props.uuid
            })
        });

        if (!response.ok) {
            throw new Error('Błąd podczas przełączania potwierdzenia wizualizacji');
        }

        const data = await response.json();

        if (data.success) {
            emit('update:visualization-confirmed', data.confirmed);
            const waitForSave = (eventName) => new Promise((resolve) => emit(eventName, resolve));
            await waitForSave('save:visualization-snap');
            if (data.confirmed) {
                await waitForSave('save:production-svg');
            }
            if (props.editAfterSave) {
                emit('update:edit-after-save', false);
            }

            window.parent.postMessage({
                type: 'VISUALIZATION_CONFIRMED',
                payload: {
                    uuid: props.uuid,
                    confirmed: data.confirmed ? 1 : 0
                }
            }, '*');
        }
    } catch (error) {
        console.error('Błąd podczas przełączania potwierdzenia:', error);
    }
}

const handleTextLayerEmit = (data) => {
    if (data) {

        let textColor = 0;
        let localColors = availableColors.value;

        if (addedImage.value && addedText.value && textLayerRef.value && imageLayerRef.value) {
            let realColors = imageLayerRef.value.getRealColors();
            localColors = realColors;

            let currentTextPantone = textLayerRef.value.getCurrentPantone() || '';

            if (realColors.find(realColor => realColor.pantone.toUpperCase() === currentTextPantone.toUpperCase())) {
                textColor = 0;
            } else {
                textColor = 1;
            }
        }


        if (isDigitalPrint.value || (props.printMethod && (props.printMethod.startsWith('L') || props.printMethod.startsWith('TC')))) {
            limitColorExceeded.value = false;
        } else {
            if (localColors.length + textColor > limitColors.value) {
                limitColorExceeded.value = true;
            } else {
                limitColorExceeded.value = false;
            }
        }
    }

    emit('update:textSettings', data)
}

const handleTextContentEmit = (data) => {
    emit('update:textContent', data)
}

const handleTextLayerRemove = () => {
    addedText.value = false;

    let localColors = availableColors.value;

    if (imageLayerRef.value) {
        localColors = imageLayerRef.value.getRealColors();
    }


    if (isDigitalPrint.value || (props.printMethod && (props.printMethod.startsWith('L') || props.printMethod.startsWith('TC')))) {
        limitColorExceeded.value = false;
    } else {
        if (localColors.length > limitColors.value) {
            limitColorExceeded.value = true;
        } else {
            limitColorExceeded.value = false;
        }
    }

    emit('remove:textContent')
}

const handleImageLayerEmit = (data) => {
    emit('update:imageSettings', data)
}

const updateQualityScore = (score) => {
    emit('update:quality-score', score)
}

const emit = defineEmits([
    'update:textSettings',
    'update:textContent',
    'update:imageSettings',
    'update:image',
    'update:colors',
    'update:colors-file',
    'download:visualization',
    'update:quality-score',
    'update:visualization-confirmed',
    'update:edit-after-save',
    'save:visualization',
    'save:visualization-snap',
    'save:production-svg',
    'remove:textContent'
])
</script>
